'use client';

import AnimatedButton from '@/components/shared/AnimatedButton';
import ArrowNext from '@/components/shared/Icon/ArrowNext';
import useDevice from '@/hooks/useDevice';
import { useModal } from '@/hooks/useModal';

import css from './style.module.scss';

const NotFoundInner = () => {
	const { openModal } = useModal();
	const device = useDevice();

	return (
		<div className={css.wrapper}>
			<div className={css.videoWrapper}>
				{device ? (
					<video key={device} autoPlay muted loop playsInline className={css.videoBackground}>
						<source
							type="video/mp4"
							src={
								device === 'desktop'
									? '/assets/video/mp4/404_video.mp4'
									: '/assets/video/mp4/viber/404_video_mobile.mp4'
							}
						/>
						Your browser does not support the video tag.
					</video>
				) : null}

				<button className={css.call} onClick={() => openModal('CALENDAR_BOOKING')}>
					call yaro
				</button>
			</div>

			<div className={css.content}>
				<p className={css.subtitle}>Damn it! This page ghosted you</p>
				<h1 className={css.title}>
					But Yaro won’t—
					<br /> he’s buzzing with ideas
				</h1>

				<AnimatedButton
					href="/"
					type="link"
					className={css.cta}
					endIconComponent={<ArrowNext size={device === 'desktop' ? 20 : 16} />}
				>
					Back to Qream
				</AnimatedButton>
			</div>
		</div>
	);
};

export default NotFoundInner;
